import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { UserModel } from "@models/user.model";
import { IndividualOperationRequest } from "@models/individualOperationRequest.model";
import { DueDateTitleValueRequest, OperationItem } from "@models/operationItem.model";
import { UpdateTitleValueDigitalRequest } from "@models/updateTitleValueDigitalRequest";
import { Observable } from "rxjs";
 
export interface OperationListResponse {
  operations: OperationItem[];
  totalPages: number;
  totalRecords: number;
}
 
@Injectable({
  providedIn: "root",
})
export class OperationService {
  private urlApi: string;
  public userToken: any;
  private tokenAlt: any;
  public identity: UserModel;
 
  constructor(private http: HttpClient) {
    this.urlApi = environment.urlApi;
    this.readToken();
    this.readTokenAlt();
    this.getIdentity();
  }
 
  readToken() {
    if (sessionStorage.getItem('tokenCF')) {
      this.userToken = sessionStorage.getItem('tokenCF');
    } else {
      this.userToken = "";
    }
    return this.userToken;
  }
 
  readTokenAlt() {
    if (sessionStorage.getItem('tokenALT')) {
      this.tokenAlt = sessionStorage.getItem('tokenALT');
    } else {
      this.tokenAlt = "";
    }
    return this.tokenAlt;
  }
 
  getIdentity() {
    return (this.identity = UserModel.fromResponse(
      JSON.parse(sessionStorage.getItem('user'))
    ));
  }
  
 
  getOperationList(
    individualOperationRequest: IndividualOperationRequest
  ) {
    individualOperationRequest.documentNumber = this.identity.userInfo.document;
    individualOperationRequest.documentType =
      this.identity.userInfo.documentType;
 
    const headers = new HttpHeaders().set("token", this.tokenAlt);
    const options = {
      params: IndividualOperationRequest.toRequest(individualOperationRequest),
      headers,
    };
 
    const pageSize = 10; 
 
    return this.http.get(`${this.urlApi}/pr_operaciones_individuales`, options).pipe(
      map((resp: any): OperationListResponse => {
        const rawOps: any[] = resp.OPERACIONES_INDIVIDUALES || [];
 
        const operations: Array<OperationItem> = rawOps.length
          ? rawOps.map((operationItem) =>
              OperationItem.fromResponse(operationItem)
            )
          : [];
 
       
        const totalRecords = rawOps.length
          ? Number(rawOps[0].N_REGISTROS || 0)
          : 0;
 
        const totalPages =
          totalRecords > 0 ? Math.ceil(totalRecords / pageSize) : 1;
 
        return { operations, totalPages, totalRecords };
      })
    );
  }

  getDueDateTitleValue(
    request: DueDateTitleValueRequest
  ): Observable<any> {

    const headers = new HttpHeaders().set("token", this.tokenAlt);

    const options = {
      params: DueDateTitleValueRequest.toRequest(request),
      headers,
    };

    return this.http
      .post(`${this.urlApi}/pr_fecha_vencimiento_titulo_valor`, {}, options)
      .pipe(
        map((resp: any) => resp)
      );
  }

  updateTitleValueDigital(
    request: UpdateTitleValueDigitalRequest
  ): Observable<any> {

    const headers = new HttpHeaders().set("token", this.tokenAlt);

    const options = {
      params: UpdateTitleValueDigitalRequest.toRequest(request),
      headers,
    };

    return this.http
      .post(`${this.urlApi}/pr_actualiza_titulo_valor_canal_digital`, {}, options)
      .pipe(
        map((resp: any) => resp)
      );
  }
}